/**
 * Hulpen bij de tijdlijn van de klant (sessie 73 blok 3): welk item
 * onder welk filter valt, en pagina's van de cursor aan elkaar plakken.
 */
import type { KaartTijdlijnItem, TijdlijnFilter } from "./types";

export type Keuze = "alles" | Exclude<TijdlijnFilter, "overig">;

/** Valt het item onder deze keuze? Retouren horen bij Bestellingen, dossierregels bij Dossier. */
export function hoortBij(item: KaartTijdlijnItem, keuze: Keuze): boolean {
  if (keuze === "alles") return true;
  if (keuze === "bestelling") return item.filter === "bestelling" || item.kanaal === "retour";
  if (keuze === "dossier") return item.filter === "dossier" || item.kanaal === "dossier";
  return item.filter === keuze && item.kanaal !== "retour" && item.kanaal !== "dossier";
}

type Regel = KaartTijdlijnItem["regels"][number];

/** Regels van twee helften samen: ontdubbeld op moment plus tekst, oud naar nieuw. */
function voegRegelsSamen(a: Regel[], b: Regel[]): Regel[] {
  const gezien = new Set<string>();
  const uit: Regel[] = [];
  for (const r of [...a, ...b]) {
    const sleutel = `${r.moment}|${r.tekst}`;
    if (gezien.has(sleutel)) continue;
    gezien.add(sleutel);
    uit.push(r);
  }
  return uit.sort((x, y) => (Date.parse(x.moment) || 0) - (Date.parse(y.moment) || 0));
}

/**
 * Alle pagina's achter elkaar, elk item één keer (op `sleutel`). Loopt een
 * zaak over de paginagrens, dan komt hij op de volgende pagina terug: zijn
 * regels gaan dan bij die van het eerdere item.
 */
export function plakPaginas(paginas: { items: KaartTijdlijnItem[] }[]): KaartTijdlijnItem[] {
  const plek = new Map<string, number>();
  const uit: KaartTijdlijnItem[] = [];
  for (const pagina of paginas) {
    for (const item of pagina.items) {
      const i = plek.get(item.sleutel);
      if (i === undefined) {
        plek.set(item.sleutel, uit.length);
        uit.push(item);
        continue;
      }
      const eerder = uit[i];
      uit[i] = { ...eerder, regels: voegRegelsSamen(eerder.regels, item.regels) };
    }
  }
  return uit;
}
